const IMPLER_TEMPLATE = {
    importJob: {
        net: '6ae81f6b2bd70c1815e3f7cc',
        app: '6ae860e32bd70c1815ea2f5a',
        com: '6ae861242bd70c1815ea3e32'
    },
}

export const getImplerTemplateId = (module) => IMPLER_TEMPLATE?.[module]?.[window.location.origin.split('.')?.[2] ?? 'net'] ?? '';

const IMPLER_PROJECT = {
    net: '65360732a3c0d8882cd85643',
    app: '65360732a3c0d8882cd85643',
    com: '654c7f39bbd057ab41d1317d'
}

export const getImplerProjectId = () => IMPLER_PROJECT?.[window.location.origin.split('.')?.[2] ?? 'net'] ?? '';

const IMPLER_TOKEN = {
    net: '7f6fc9b004af9305a9d3595ea93af76d',
    app: '7f6fc9b004af9305a9d3595ea93af76d',
    com: '70c04552f7e9d17c9a82f14ae9a43540'
}

export const getImplerTokenId = () => IMPLER_TOKEN?.[window.location.origin.split('.')?.[2] ?? 'net'] ?? '';
